import type { NavGroup, NavPage } from "../features/registry";
import { AppLink } from "./AppLink";

interface SectionTabsProps {
  group: NavGroup;
  /** The page being shown, which gets the underline. */
  page: NavPage;
}

/**
 * The row of tabs shared by every page in a multi-page nav group (League's
 * Managers, Hall of Fame, Luck and Biggest Blowout, say). Plain links, so each
 * page keeps its own shareable URL. Renders nothing for a group of one.
 */
export function SectionTabs({ group, page }: SectionTabsProps) {
  if (group.pages.length < 2) return null;
  return (
    <nav className="section-tabs" aria-label={`${group.label} sections`}>
      {group.pages.map((p) => (
        <AppLink key={p.path} href={p.path} className="section-tabs__tab" aria-current={p.path === page.path ? "page" : undefined}>
          {p.label}
        </AppLink>
      ))}
    </nav>
  );
}
